import angular from 'angular';
import { MovimentacoesPeriodoFormController } from './movimentacoes-periodo-form.controller';

export class MovimentacoesPeriodoFormComponent implements angular.IComponentOptions {
    static selector = 'movimentacoesPeriodoForm';
    static controller = MovimentacoesPeriodoFormController;
    static template = require('!!html-loader!./movimentacoes-periodo-form.component.html');
    static bindings = {
        model: '=',
        busy: '<',
        submitLabel: '@?',
        busyLabel: '@?',
        cancelLabel: '@?',
        showCancel: '<?',
        showSituacao: '<?',
        disableCompetencia: '<?',
        readOnly: '<?',
        months: '<?',
        years: '<?',
        statusOptions: '<?',
        onSubmit: '&',
        onCancel: '&?'
    };
}
